import React, { useState, useEffect } from "react";
import { useHistory, Redirect } from "react-router-dom";

import moment from "moment";

import {
  makeStyles,
  Grid,
  Container,
  TextField,
  InputAdornment,
  Paper,
  Button,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";

import StackingListView from "./StackingListView";

import { getPools } from "../../apiFunctions";

const useStyles = makeStyles((theme) => ({
  paperContainer: {
    borderRadius: theme.spacing(2),
    width: "100%",
    height: "200px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  ul: {
    listStyle: "none",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "16px",
    padding: "2px",
    margin: "0",
    maxWidth: "min-content",
  },
  li: {
    cursor: "pointer",
    display: "flex",
    flexFlow: "row nowrap",
    borderRadius: "14px",
    outline: "none",
    textDecoration: "none",
    fontSize: ".8rem",
    fontWeight: "500",
    padding: "9px 13px",
    wordBreak: "break-word",
    overflow: "hidden",
    whiteSpace: "nowrap",
    "&.active": {
      backgroundColor: theme.palette.background.default,
    },
  },
  customInput: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: "20px",
  },
  searchIcon: {
    color: theme.palette.grey[400],
  },
  createButton: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: "14px",
    minWidth: "max-content",
    marginRight: theme.spacing(2),
    padding: "8px 16px",
    boxShadow: "none !important",
  },
  formControl: {
    marginRight: theme.spacing(1),
    minWidth: 120,
  },
}));

function UpdateStaking({ network }) {
  const history = useHistory();
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [pools, setPools] = useState({
    lives: [],
    finished: [],
  });
  const [live, setLive] = useState(true);
  const [search, setSearch] = useState("");

  // List view
  const [expanded, setExpanded] = useState("");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const get_pools_data = async () => {
    // start loading
    setLoading(true);

    // set variable
    let params = new URLSearchParams();
    params.set("chainId", network.chainID);

    await getPools(params).then((res) => {
      if (res) {
        let livePolls = [];
        let finishedPolls = [];
        let currentTimeStamp = moment().unix();
        for (let i = 0; i < res.length; i++) {
          const pool = res[i];

          if (+pool.period_finish > currentTimeStamp) {
            livePolls.push(pool);
          } else {
            finishedPolls.push(pool);
          }
        }

        let poolsList = { ...pools };
        poolsList.lives = livePolls;
        poolsList.finished = finishedPolls;
        setPools(poolsList);
      }
    });

    setLoading(false);
  };

  const filteredPools = () => {
    var items = pools[live ? "lives" : "finished"],
      pool = search;

    if (!pool) {
      return items;
    }

    pool = pool.trim().toLowerCase();

    items = items.filter((item) => {
      if (item.staking_token.lptokens) {
        if (
          item.rewards_token.symbol.toLowerCase().indexOf(pool) !== -1 ||
          item.rewards_token.name.toLowerCase().indexOf(pool) !== -1 ||
          item.staking_token.symbol.toLowerCase().indexOf(pool) !== -1 ||
          item.staking_token.name.toLowerCase().indexOf(pool) !== -1 ||
          item.staking_token.lptokens.token0.symbol
            .toLowerCase()
            .indexOf(pool) !== -1 ||
          item.staking_token.lptokens.token0.name
            .toLowerCase()
            .indexOf(pool) !== -1 ||
          item.staking_token.lptokens.token1.symbol
            .toLowerCase()
            .indexOf(pool) !== -1 ||
          item.staking_token.lptokens.token1.name
            .toLowerCase()
            .indexOf(pool) !== -1
        ) {
          return item;
        }
      } else if (
        item.rewards_token.symbol.toLowerCase().indexOf(pool) !== -1 ||
        item.rewards_token.name.toLowerCase().indexOf(pool) !== -1 ||
        item.staking_token.symbol.toLowerCase().indexOf(pool) !== -1 ||
        item.staking_token.name.toLowerCase().indexOf(pool) !== -1
      ) {
        return item;
      }
    });

    // Return an array with the filtered data
    return items;
  };

  useEffect(() => {
    const stackTimeout = setTimeout(() => {
      if (network.stacking) {
        get_pools_data();
      }
    }, 1000);
    return () => clearTimeout(stackTimeout);
  }, []);

  return (
    <>
      {network.chainID != 56 ? (
        <div id="stacking">
          <Container maxWidth="xl">
            <Grid container className="mb-4" spacing={2}>
              <Grid item xs={12} sm={6} md={8}>
                <ul className={classes.ul}>
                  <li
                    onClick={() => setLive(!live)}
                    className={`${classes.li} ${live ? "active" : ""}`}
                  >
                    Live
                  </li>
                  <li
                    onClick={() => setLive(!live)}
                    className={`${classes.li} ${!live ? "active" : ""}`}
                  >
                    Not Live
                  </li>
                </ul>
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                className="d-flex align-items-center"
              >
                <Button
                  variant="contained"
                  className={classes.createButton}
                  onClick={() => history.push("/create-staking-pool")}
                >
                  create pool
                </Button>
                <TextField
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  variant="outlined"
                  placeholder="Search..."
                  fullWidth
                  className="custom-search"
                  classes={{ root: classes.customInput }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon className={classes.searchIcon} />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>

            {(!filteredPools().length || loading) && (
              <Grid container>
                <Paper elevation={0} className={classes.paperContainer}>
                  {loading ? "Loading..." : "No Pool To Show"}
                </Paper>
              </Grid>
            )}
            {filteredPools().map((item) => (
              <StackingListView
                key={item.id}
                item={item}
                network={network}
                active={expanded === `panel${item.id}`}
                handleChange={handleChange}
                expired={live ? false : true}
              />
            ))}
          </Container>
        </div>
      ) : (
        <Redirect to="/invest" />
      )}
    </>
  );
}

UpdateStaking.propTypes = {};

export default UpdateStaking;
